import './App.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';

function ContactSupport() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');

    try {
      const response = await fetch('https://formspree.io/f/mzzalnlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formState)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormState({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
  };

  return (
    <div className="App">
      <nav>
        <div className="logo">
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <img src="/iconyomuya.png" alt="Yomiya" style={{ height: '24px', width: '24px', marginRight: '8px', verticalAlign: 'middle' }} />
            Yomiya
          </Link>
        </div>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/#features">Features</Link></li>
          <li><Link to="/#use-cases">For You</Link></li>
          <li><Link to="/#testimonials">Stories</Link></li>
        </ul>
      </nav>

      <section className="contact-support-section" id="ContactSupport">
        <div className="contact-container">
          <h1 className="contact-title">Contact Support</h1>
          <p className="contact-subtitle">
            Have a question or need help? We're here for you. Send us a message and we'll get back to you as soon as possible.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formState.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formState.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formState.subject}
                onChange={handleChange}
                required
                placeholder="What's this about?"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formState.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Tell us what you need help with..."
              />
            </div>

            <button type="submit" className="submit-btn" disabled={submitStatus === 'sending'}>
              {submitStatus === 'sending' ? 'Sending...' : 'Send Message'}
            </button>

            {submitStatus === 'success' && (
              <div className="status-message success">
                Thank you! Your message has been sent successfully. We'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="status-message error">
                Oops! Something went wrong. Please try again or email us directly.
              </div>
            )}
          </form>
        </div>
      </section>

      <footer>
        <p>&copy; 2025 Yomiya. Made with care for real people.</p>
        <p
          style={{
            marginTop: '1rem',
            fontSize: '0.9rem',
          }}
        >
          <Link to="/privacy">Privacy</Link> •{' '}
          <Link to="/terms">Terms</Link> •{' '}
          <Link to="/contactSupport">Contact</Link> •{' '}
          <a href="https://yomiya.proksiyazilim.com">Blog</a>
        </p>
      </footer>
    </div>
  );
}

export default ContactSupport;
